import { getGetPublicConfigQueryOptions, useGetPublicConfig } from '@pa/api/public'
import type { QueryClient } from '@tanstack/react-query'

/**
 * `GET …/config` (#1) for the clinic of the URL (Frontend §4.2). The booking flow loads it at boot and on the
 * "existing" re-check (`fetchClinicConfig`); screens read the cached copy here. `no-store` on the server: never
 * refetched by itself.
 */
export function useClinicConfig(slug: string) {
  return useGetPublicConfig(slug, {
    query: { enabled: false, staleTime: Infinity, refetchOnWindowFocus: false, refetchOnReconnect: false },
  })
}

/** Loads #1 now (`fresh`: ignore the cache, the "existing" re-check, API.md §4.1) and keeps it for the screens. */
export function fetchClinicConfig(queryClient: QueryClient, slug: string, fresh = false) {
  return queryClient.query({ ...getGetPublicConfigQueryOptions(slug), staleTime: fresh ? 0 : Infinity })
}
